const tags = {
  new: {
    label: "NEW",
    backgroundColor: "#3273fa",
    fontColor: "#fff",
  },
  beta: {
    label: "BETA",
    backgroundColor: "#24a87b",
    fontColor: "#fff",
  },
  soon: {
    label: "SOON™",
    backgroundColor: "#25254b",
    fontColor: "#cddcfe",
  },
  hot: {
    label: "HOT!",
    backgroundColor: "#dd2735",
    fontColor: "#fff",
  },
};

const gamesDataRaw = [
  {
    img: "game-library_lol.jpg",
    title: "League of Legends",
    url: "https://u.gg",
    code: "lol",
  },
  {
    img: "game-library_val.jpg",
    title: "Valorant",
    tag: tags.hot,
    url: "https://u.gg/val",
    code: "val",
  },
  {
    img: "deadlock-game.png",
    title: "Deadlock",
    url: "https://tracklock.gg",
    tag: tags.new,
    code: "tracklock",
  },
  {
    img: "rematch-game-library.webp",
    title: "Rematch",
    url: "https://u.gg/rematch",
    code: "rematch",
  },
  {
    img: "game-library_tft.jpg",
    title: "Teamfight Tactics",
    url: "https://u.gg/tft/comps",
    code: "tft",
  },
  {
    img: "game-library_wow2.png",
    title: "World of Warcraft",
    url: "https://u.gg/wow",
    code: "wow",
  },
  {
    img: "game-library_hd2.jpg",
    title: "Helldivers 2",
    url: "https://u.gg/hd2",
    code: "hd2",
  },
  {
    img: "more-games-soon.png",
    title: "Coming Soon",
    code: "soon",
  },
  // {
  //   img: "game-library_more-games.svg",
  //   title: "Stay Tuned...",
  //   tag: tags.soon,
  // },
];

function getGameData(utmSource: string, utmCampaignGameCode: string) {
  return gamesDataRaw.map((game) => {
    if (!game.url) {
      return { ...game, url: undefined };
    }
    const gameUrl = new URL(game.url || "#");
    gameUrl.searchParams.set("utm_source", utmSource);
    gameUrl.searchParams.set("utm_campaign", `gs2-${utmCampaignGameCode}2${game.code}`);
    return { ...game, url: gameUrl.toString() };
  });
}

const DEFAULT_UTM_SOURCE = "ugghome";

export function GameLibraryContainer({
  utmSource = DEFAULT_UTM_SOURCE,
  utmCampaignGameCode,
}: {
  utmSource: string;
  utmCampaignGameCode: string;
}) {
  const gamesDataWithLinks = getGameData(utmSource, utmCampaignGameCode);
  return (
    <div className="mt-3 flex flex-col items-start gap-9 w-full max-w-[1016px] mx-auto md:px-3 px-3 lg:px-0">
      <h2 className="text-white font-inter text-[24px] font-bold">Games</h2>
      <div className="grid grid-cols-2 xs:grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-x-[18px] gap-y-6">
        {gamesDataWithLinks.map((game, index) => {
          const GameContainer = () => (
            <div className="relative group w-full">
              {game.tag && (
                <div
                  className="absolute -right-1.5 top-1.5 z-10 rounded-sm px-1 py-0.5 text-[10px] font-bold shadow-[0px_1px_1px_0px_rgba(0,0,0,0.4)]"
                  style={{ backgroundColor: game.tag.backgroundColor, color: game.tag.fontColor }}
                >
                  {game.tag.label}
                </div>
              )}
              <div className="relative w-full h-[250px] rounded-md overflow-hidden group/imgc">
                <img
                  src={`https://static.bigbrain.gg/assets/lol/landing/game-library/${game.img}` || ""}
                  alt={game.img || "Game image"}
                  className="block w-full h-full object-cover"
                />
                <div className="hidden absolute inset-0 bg-white/50 mix-blend-soft-light rounded-md group-hover/imgc:block"></div>
              </div>
              <div className="mt-2 text-white font-inter text-sm font-bold">{game.title}</div>
            </div>
          );

          return game.url ? (
            <a key={index} href={game.url} target="_blank" rel="noopener noreferrer" className="block">
              <GameContainer />
            </a>
          ) : (
            <div key={index} className="block">
              <GameContainer />
            </div>
          );
        })}
      </div>
    </div>
  );
}
